import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { tabletBreakpoint, fromTabletBreakpoint } from '@/src/domains/shared/breakpoints';
import {
  SecondComparisonTableWrapper as SecondComparisonTableWrapperComponent,
  Section as SectionComponent,
  TableRowItem as TableRowItemComponent,
  TableHeading as TableHeadingComponent,
  TableRow as TableRowComponent,
  ThirdTableHeading as ThirdTableHeadingComponent,
} from '@/src/views/EntityCost/ComparisonTableSlice';

export const Section = styled(SectionComponent)`
  && {
    --brandPrimary: #5700ff;
    --brandSecondary: #f8f5ff;
    --borderColor: #d4d7df;
    ${fluidProp(['padding-bottom', 'padding-top'], '80px', '164px')}
    font-family: var(--typography-fontBrand);
    overflow: hidden;
  }
`;

export const ComparisonTableWrapper = styled.div`
  ${fluidProp('padding-bottom', '50px', '80px')}
`;

export const ThirdTableHeading = styled(ThirdTableHeadingComponent)`
  && {
    border-bottom: 1px solid ${({ theme }) => theme.colors.spindle_75};
    border-top: 1px solid ${({ theme }) => theme.colors.spindle_75};
  }
`;

export const CheckIconWrapper = styled.div`
  svg {
    fill: var(--colors-blank);
  }
`;

export const CloseIconWrapper = styled.div`
  svg {
    fill: red;
  }
`;

export const SecondComparisonTableWrapper = styled(SecondComparisonTableWrapperComponent)`
  ${CheckIconWrapper} {
    svg {
      fill: var(--colors-irisBlue);
    }
  }
`;

export const TableRowItem = styled(TableRowItemComponent)`
  && {
    border-bottom: 1px solid ${({ theme }) => theme.colors.spindle_75};
    height: 55px;
  }
`;

export const TableHeading = styled(TableHeadingComponent)`
  &:first-child {
    border: none;
  }

  &:nth-child(2) {
    background-color: var(--brandPrimary);
    color: var(--brandSecondary);
  }

  &:nth-child(3) {
    text-transform: none;
    ${({ theme }) => theme.typography.titleSM}
  }
`;

export const ThirdColumnTitle = styled(TableHeading)`
  color: var(--brandPrimary);
`;

export const TableRow = styled(TableRowComponent)`
  &:last-child {
    ${TableRowItem} {
      border-right: 1px solid var(--borderColor);
      border-left: 1px solid var(--borderColor);

      ${fromTabletBreakpoint(css`
        border: none;
      `)}

      ${tabletBreakpoint(css`
        display: flex;

        &:nth-child(2) {
          display: flex;
          min-height: 113px;
          border-bottom: 1px solid ${({ theme }) => theme.colors.spindle_75};
          border-top: 1px solid ${({ theme }) => theme.colors.spindle_75};
        }
      `)}
    }
  }

  ${TableRowItem} {
    width: 29%;

    ${tabletBreakpoint(css`
      width: 100%;

      > * {
        text-align: center;
      }
    `)}

    &:first-child {
      width: 42%;

      ${tabletBreakpoint(css`
        width: 100%;
      `)}
    }

    &:nth-child(2) {
      background-color: var(--brandPrimary);
    }

    &:nth-child(3) {
      ${CheckIconWrapper} {
        svg {
          fill: var(--colors-irisBlue);
        }
      }
      ${tabletBreakpoint(css`
        display: none;
      `)}
    }
  }
`;

export const ThirdTableRow = styled(TableRow)`
  ${TableRowItem} {
    &:nth-child(2) {
      background-color: none;
      background-image: var(--colors-zircon);
      color: var(--colors-bayoux);
      border-color: var(--borderColor);
      border-width: 1px;
    }
  }
`;

export const Title = styled.div`
  color: var(--colors-darkBlue);
  ${({ theme }) => theme.typography.titleXL}
  font-family: var(--typography-fontBossa);
  margin-bottom: 80px;
`;

export const Header = styled.div`
  text-align: center;
`;

export const Note = styled.div`
  ${({ theme }) => theme.typography.bodyXS}
`;

export const TableLeftBgWrapper = styled.div`
  width: 80%;
  height: 45%;
  background-color: var(--brandSecondary);
  position: absolute;
  left: -30%;
  bottom: 0;
  border-top-right-radius: 100%;
  z-index: -1;

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export const TableRightBgWrapper = styled(TableLeftBgWrapper)`
  left: unset;
  right: -30%;
  border-top-right-radius: 0;
  border-top-left-radius: 100%;
`;
